import React from 'react';
import CheckIcon from '@mui/icons-material/Check';
export function OfferReveal() {
  return <section className="py-8 md:py-12 px-4 bg-brand-purple text-white text-center" data-id="element-187">
      <div className="max-w-4xl mx-auto" data-id="element-188">
        <h2 className="font-heading text-xl md:text-2xl font-bold mb-5 text-brand-cream" data-id="element-189">
          🎨 ¿Y si este fuera el momento de aprender una habilidad que te
          acompañe toda la vida?
        </h2>

        <div className="inline-block bg-white/10 px-4 py-1.5 rounded-full mb-3 border border-white/20" data-id="element-190">
          <span className="text-base font-bold tracking-wider" data-id="element-191">
            🏆 ARTE BORDADO™
          </span>
        </div>

        <h3 className="text-base md:text-xl font-bold mb-4 text-brand-pink" data-id="element-192">
          TOMO 1 + TOMO 2 + 4 BONOS EXCLUSIVOS
        </h3>

        <p className="text-base mb-4 text-brand-cream/90" data-id="element-193">
          Todo explicado paso a paso para que puedas:
        </p>

        <div className="flex flex-wrap justify-center gap-2 md:gap-4" data-id="element-194">
          {['aprender', 'crear', 'perfeccionar', 'vender si lo deseás'].map((item, i) => <div key={i} className="flex items-center gap-2 bg-white/5 px-3 py-1.5 rounded-lg" data-id="element-195">
                <CheckIcon className="text-brand-pink" fontSize="small" data-id="element-196" />
                <span className="font-semibold text-sm md:text-base" data-id="element-197">
                  {item}
                </span>
              </div>)}
        </div>
      </div>
    </section>;
}